import React from 'react';
import { Form, Input, Button,Spin,Select,Switch } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

const { Option } = Select;

class ActionUpdateForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    type_group:'',
    description:'',
    auto_trigger:false


  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({name:this.props.action_obj.name})
    this.setState({type_group:this.props.action_obj.type_group})
    this.setState({description:this.props.action_obj.description})
    this.setState({auto_trigger:this.props.action_obj.auto_trigger})

    this.setState({datarequested:false})


  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('name', this.state.name);
    form_data.append('type_group', this.state.type_group);
    form_data.append('description', this.state.description);
    form_data.append('auto_trigger', this.state.auto_trigger);

    axios.put(serverconfig.backendserverurl+`/api/actions/${this.props.action_obj.id}/`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

  }    

  )
  .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="name"
       
      >
        <Input name="name"  placeholder="name." value={this.state.name} onChange={(val)=>{this.setState({name:val.target.value})}} />
      </FormItem>


      <FormItem label="description">
        <TextArea
            placeholder="description"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.description}
            onChange={(val)=>{this.setState({description:val.target.value})}}
          />
        
      </FormItem>


      <FormItem label="Action Type Group"
     
      >
          <Select 
          placeholder="Type Group" 
          style={{  }} 
          value={this.state.type_group}
          onChange={(val)=>{
            this.setState({type_group:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
                <Option value={'Application'}>{'Application'}</Option>
                <Option value={'Communication'}>{'Communication'}</Option>
                <Option value={'Generic'}>{'Generic'}</Option>
                <Option value={'Granting'}>{'Granting'}</Option>
                <Option value={'Hold'}>{'Hold'}</Option>
                <Option value={'Payment'}>{'Payment'}</Option>
                <Option value={'Renewal'}>{'Renewal'}</Option>
                <Option value={'Shape Change'}>{'Shape Change'}</Option>
                <Option value={'Shape Validation'}>{'Shape Validation'}</Option>
                <Option value={'Survey'}>{'Survey'}</Option>
                <Option value={'Termination'}>{'Termination'}</Option>
                <Option value={'Transfer'}>{'Transfer'}</Option>
                <Option value={'Work Commitment'}>{'Work Commitment'}</Option>

          </Select>
      </FormItem>


      <Form.Item label="Auto Triggered?" >
            <Switch
                checked={this.state.auto_trigger}
                onChange={val=>{this.setState({auto_trigger:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
      </Form.Item>


      <FormItem>
        <Button  type="primary" htmlType="submit">Update Action</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default ActionUpdateForm;



